import goto from ".";
import { isInsideWebView } from "./utils";

/** Entry point each shop pageset declares right before its PDP. */
export const SHOP_PDP_ENTRY_POINT = "pdp";

/** Entry point each shop pageset declares on its checkout. */
export const SHOP_CHECKOUT_ENTRY_POINT = "shopCheckout";

export default {
  /**
   * Leaves a shop eligibility survey after an ineligible answer: closes the
   * webview in the app, and returns web users to the product's PDP.
   */
  shopIneligibilityExit() {
    if (isInsideWebView()) {
      goto.closeInAppWebview();
      return;
    }
    goto.jumpToEntryPoint(SHOP_PDP_ENTRY_POINT);
  },
};
